import { Stack } from '@mui/material'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import moment from 'moment'
import { useAppSelector } from 'store/hooks'
import DonutChart from 'ui/charts/donut-chart/DonutChart'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { normalizeFatnessCategories } from 'utils/fatnessCategories'
import { BaseWidget } from '../baseWidget'
import { FatnessWidgetTable } from './Table/FatnessWidgetTable'

export const FatnessWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_fatness || error) return null
	const fatness = statistics?.fatness
		? normalizeFatnessCategories(statistics.fatness).filter(el => el.value > 0)
		: undefined
	const categories = fatness?.map(el => el.value)
	const colors = fatness?.map(el => el.color)
	const milky = statistics?.herd?.milky
	const dry = statistics?.herd?.dry
	const totalCattle = milky == null || dry == null ? 0 : milky + dry
	const todayLabel = moment().format('DD.MM.YY')
	return (
		<BaseWidget
			isLoading={loading}
			path='/cattles/fatness'
			pathLable='Смотреть список'
		>
			<Stack direction='row' alignItems='center' gap='8px' mb='24px'>
				<TypographyPrimary16Bold>Упитанность</TypographyPrimary16Bold>
				<TypographySecondary>{todayLabel}</TypographySecondary>
			</Stack>
			<Stack direction='row' justifyContent='center'>
				<DonutChart colors={colors} categories={categories} height='126px' />
			</Stack>
			<FatnessWidgetTable fatness={fatness} totalCattle={totalCattle} />
		</BaseWidget>
	)
}
